module.exports = __webpack_public_path__ + "img/p14.5fe079d6.png";